export default "__VITE_ASSET__C9JioWpd__"